<template>
    <div class="specialView-container">
        <section class="specialView-image_container okView-color">
            <span class="specialView-image okView-image"></span>
        </section>
        <section class="specialView-info_container ">
            <h2 class="specialView-info_title" > ¡Listo! Vamos a continuar el estudio de tu hipoteca con Helloteca</h2>
            <p class="specialView-info_text">La operación que quieres realizar será analizada por Helloteca, socio de MyInvestor especializado en gestiones hipotecarias específicas como la que tu necesitas.</p>
            <div class="okview-action_container">
                <button class="button primary rounded" @click="goEnd()" >
                    Entendido
                </button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'OKView',
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        goEnd() {
            window.location.href = 'https://myinvestor.es/hipotecas/';
        }
    }
}
</script>

<style scoped>
    .okView-color {
        background: #DFF1ED;
    }
    .okView-image {
        width: 508px;
        height: 271px;
        flex-shrink: 0;
        background: url(../../assets/laptop.png) #DFF1ED 50% / cover no-repeat;
    }
    .okview-button_container{
        justify-content: center;
        width: 100%;
    }
    /* MOVIL */
    @media (max-width: 768px) {
        .okView-image {
            display: none;        }
        .okview-action_container {
            width: 100%;
        } 
    }

</style>
